import React, { useEffect, useState } from "react";
import { useGetOrganizationDetail } from "../api/organization";
import { useParams } from "react-router-dom";
import { Table, Card, Badge } from "antd";

const usersColumn = [
  {
    title: "No.",
    width: 50,
    render: (text: any, record: any, index: number) => <b>#{index + 1}</b>,
  },
  { dataIndex: "fullName", title: "Full Name" },
  { dataIndex: "email", title: "Email" },
  { dataIndex: "username", title: "Username" },
  { dataIndex: "phone", title: "Phone Number" },
  { dataIndex: "roleName", title: "Role" },
];

function BranchDetailPage() {
  const { id } = useParams();
  const { data: branch, refetch } = useGetOrganizationDetail(id);
  interface Address {
    region?: string;
    city?: string;
    kifleKetema?: string;
    woreda?: string;
    house_number?: string;
  }
  
  const [address, setAddress] = useState<Address | null>(null);
  interface User {
    fullName: string;
    phoneNo: string;
    email: string;
  }

  const [contactPerson, setContactPerson] = useState<User | null>(null);
  const [numberOfUsers, setNumberOfUsers] = useState(0);

  useEffect(() => {
    if (id) refetch();
  }, [id]);

  useEffect(() => {
    if (branch?.data?.data) {
      const { address: addressData, user } = branch.data.data;
      if (addressData) setAddress(JSON.parse(addressData));
      if (user?.length) {
        setNumberOfUsers(user.length);
        setContactPerson(user.find((u: User) => u));
      }
    }
  }, [branch]);

  return (
    <div className="p-6 space-y-6 bg-gray-100 min-h-screen"    style={{ fontFamily: "Roboto"}}>
      {branch?.data && (
         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
         <Card className="shadow-md p-6 rounded-lg bg-gray-200">
           <h2 className="text-xl font-semibold mb-4 text-black">Branch Info</h2>
           <div className="space-y-3 text-gray-700">
             <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">Branch Name</h2>
                  <Badge className="text-gray-800">{branch.data.data.name}</Badge>
               </div>
             <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">Phone</h2>
                  <Badge className="text-gray-800">{branch.data.data.phoneNo}</Badge>
               </div>
               <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">Email</h2>
                  <Badge className="text-gray-800">{branch.data.data.email}</Badge>
               </div>
             <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">No. of Users</h2>
                  <Badge className="text-gray-800">{branch.data.data.numberOfUsers}</Badge>
               </div>
             <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">Region</h2>
                  <Badge className="text-gray-800">{branch.data.data.region}</Badge>
               </div>
             <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">City</h2>
                  <Badge className="text-gray-800">{branch.data.data.city}</Badge>
               </div>
             <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">Kifle Ketema</h2>
                  <Badge className="text-gray-800">{branch.data.data.kifleKetema}</Badge>
               </div>
             <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">Woreda</h2>
                  <Badge className="text-gray-800">{branch.data.data.woreda}</Badge>
               </div>
             <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">House No.</h2>
                  <Badge className="text-gray-800">{branch.data.data.house_number}</Badge>
               </div>
           </div>
         </Card>

         <Card className="shadow-md p-6 rounded-lg bg-gray-200 font-[Roboto]">
           <h2 className="text-xl text-black font-semibold mb-4">Contact Person</h2>
           {contactPerson ? (
             <div className="space-y-3">
               <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">Full Name</h2>
                  <Badge className="text-gray-800">{contactPerson?.fullName}</Badge>
               </div>
               <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">Phone</h2>
                  <Badge className="text-gray-800">{contactPerson?.phoneNo}</Badge>
               </div>
               <div className="flex justify-between items-center border-b py-2">
                  <h2 className="text-base text-zinc-700 font-semibold">Email</h2>
                  <Badge className="text-gray-800">{contactPerson?.email}</Badge>
               </div>
             </div>
           ) : (
             <p className="text-gray-500">No contact person assigned.</p>
           )}
         </Card>
       </div>
      )}

      {/* Users Table */}
      {branch?.data?.data?.user?.length > 0 && (
        <Card className="shadow-md p-6 rounded-lg">
          <h2 className="text-xl font-semibold mb-4">Users</h2>
          <Table
            dataSource={branch?.data.data.user}
            columns={usersColumn}
            rowKey="id"
            pagination={{ pageSize: 5 }}
          />
        </Card>
      )}
    </div>
  );
}

interface DetailItemProps {
  label: string;
  value: string | number | null | undefined;
  boldLabel?: boolean;
}

const DetailItem = ({ label, value }: DetailItemProps) => (
  <div className="flex justify-between items-center border-b py-2">
    <span className="text-gray-700 font-medium">{label}:</span>
    <Badge className="text-gray-800">{value || "N/A"}</Badge>
  </div>
);

export default BranchDetailPage;
